"use client";
import { useEffect, useState } from "react";
import useScript from "@portal/app/_components/hooks/useScript";

interface EsyohWidgetProps {
  vocationId?: string;
}

export interface EsyohWidgetConfig {
  widget_id: string;
  name: string;
}

export const WIDGET_CONFIG: Record<string, EsyohWidgetConfig> = {
  clorjc0ga1roe25nz5s5f2fzi: {
    // Chef
    widget_id: "875622",
    name: "Chef",
  },
  cljeoe5y7psgq3dkq3x1n0to0: {
    // Wind Turbine
    widget_id: "903497",
    name: "Wind Turbine",
  },
  cljeogiw1psma3dkqc0pv32q8: {
    // Tower Technician
    widget_id: "957059",
    name: "Tower Technician",
  },
};

export const EsyohWidget = ({ vocationId }: EsyohWidgetProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const { loading, error } = useScript("https://www.esyoh.com/clients/js/widget.js?ver=3.0.0");

  const widgetConfig = vocationId ? WIDGET_CONFIG[vocationId as keyof typeof WIDGET_CONFIG] : null;

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!loading && !error && widgetConfig && window.ESY && isMounted) {
      // Add a small delay to ensure DOM is ready
      setTimeout(() => {
        window.ESY?.Widget({
          domain_id: "dreambound.com",
          widget_id: widgetConfig.widget_id,
        });
      }, 100);
    }
  }, [loading, error, widgetConfig, isMounted]);

  if (!widgetConfig) {
    return null;
  }

  // Only render after client-side mount to avoid hydration issues
  if (!isMounted) {
    return null;
  }

  if (loading) {
    return (
      <div>
        <div className="esy_widget_container">
          <p>Loading widget...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <div className="esy_widget_container">
          <p>Widget unavailable</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="esy_widget_container" />
    </div>
  );
};
